import { jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { useExpandedFdocContext } from './ExpandedFdocProvider.js';
import { Modal } from '@fabric-app/ui/components/Modal/Modal';
import { cssVar } from '@fabric-app/ui/theme/variables';
import Skeleton from '@fabric-app/ui/components/Skeleton';

const AbsoluteClose = styled(Modal.Close).withConfig({
  displayName: "ExpandedFdocLoading__AbsoluteClose",
  componentId: "sc-9ed637b1-0"
})([
  `position:absolute;top:18px;right:16px;z-index:10;`
]);
const ContentSkeleton = styled(Skeleton).attrs((p) => {
  return {
    ...p,
    children: /* @__PURE__ */ jsx(AbsoluteClose, {
      onPointerUp: p.onClose
    })
  };
}).withConfig({
  displayName: "ExpandedFdocLoading__ContentSkeleton",
  componentId: "sc-9ed637b1-1"
})([
  `width:100%;height:100%;max-width:400px;max-height:300px;margin-left:auto;margin-right:auto;background:`,
  `;border-radius:20px;box-shadow:0px 4px 4px rgba(128,128,128,0.04),0px 4px 25px rgba(128,128,128,0.1);`
], cssVar["color-bg-tertiary"]);
const LoadingSidebarUI = styled(Skeleton).withConfig({
  displayName: "ExpandedFdocLoading__LoadingSidebarUI",
  componentId: "sc-9ed637b1-2"
})([
  `--shimmer-colour-rgb:50,50,50;min-width:360px;max-width:360px;width:100%;height:100%;flex-shrink:0;background:rgba(0,0,0,0.8);border-radius:20px;`
]);
const SidebarSkeleton = () => {
  const { sidebarOpen } = useExpandedFdocContext();
  if (!sidebarOpen) {
    return null;
  }
  return /* @__PURE__ */ jsx(LoadingSidebarUI, {});
};

export { ContentSkeleton, SidebarSkeleton };
//# sourceMappingURL=ExpandedFdocLoading.js.map
